import { ImpSelect } from '@imprint-payments/imprint-ui';

import { EVENT } from '../../analytics/analyticsConsts';
import { MODAL_ENUM, setShowModal } from '../../app/applicationScreenSlice';
import { useAppSelector, useImpState } from '../../app/hooks';
import { setLanguage } from '../../app/languageSlice';
import { ANALYTICS } from '../../firebase/firebase';
import { setSessionLanguage } from '../../utils/functionUtils';
import { LanguageCode } from '../../utils/language';

export function LanguageSelection() {
  const { dispatch, languageCode } = useImpState();
  const env = useAppSelector((state) => state.apiScreenScreenSelector.env);

  const changeLanguage = (language: string): void => {
    ANALYTICS.logEvent(EVENT.LANGUAGE_SELECTION_CLICKED, {
      page: 'languageSelectionPage',
      language: language,
    });
    if (language === LanguageCode.English) {
      setSessionLanguage(LanguageCode.English, env);
      dispatch(setLanguage(LanguageCode.English));
    }
    if (language === LanguageCode.Spanish && languageCode !== language) {
      dispatch(setShowModal(MODAL_ENUM.showLanguageDisclaimerModal));
    }
  };

  const options = [
    { value: LanguageCode.English, label: 'English' },
    {
      value: LanguageCode.Spanish,
      label: 'Spanish',
    },
  ];

  return (
    <ImpSelect
      options={options}
      label={'Language'}
      onOptionChange={changeLanguage}
      maxWidth={'100%'}
      defaultOption={options.find(({ value }) => value === languageCode)}
    />
  );
}
